//性别
export const logLevelOptions = [
    { key: '1', value: '提示' },
    { key: '2', value: '错误' },
    { key: '3', value: '警告' }
]

export const roleTypeOptions = [
    { key: '1', value: '超级管理员' },
    { key: '2', value: '单位管理员' },
    { key: '3', value: '教员' },
    { key: '4', value: '制作方负责人' },
    { key: '5', value: '制作团队成员' },
    { key: '6', value: '专家' }
]

// 课程
export const courseTypeOptions = [
    { key: '1', value: 'MOOC' },
    { key: '2', value: '微课' },
    { key: '3', value: '慕课' },

]

// 负责人
export const principalTypeOptions = [
    { key: '1', value: '单位' },
    { key: '2', value: '部门' },

]

// 流程
export const processTypeOptions = [
    { key: '1', value: '部门审核' },
    { key: '2', value: '课程组审核' },
    { key: '3', value: '教研室审核' },
]

// 课程立项环节流程
export const courseProcessTypeOptions = [

    { key: "2", value: "课程组审核" },
    { key: "3", value: "教研室审核" },
    { key: "4", value: "教研系审核" },
    { key: "5", value: "学院审核" },
    { key: "6", value: "结束" },

]

// 方案审核流程
export const SchemeProcessTypeOptions = [
    { key: '1', value: '申请' },
    { key: '2', value: '方案提交' },
    { key: '3', value: '需求人员' },
    { key: '4', value: '部门审核' },
    { key: '5', value: '课程组审核' },
    { key: '6', value: '教研室审核' },
    { key: '100', value: '结束' },
]
